module.exports = __webpack_public_path__ + "static/egg-computer-startup-screen-icon-ddadc06c117d545fbfa207223af760d4.png";